export default function Footer() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-xl font-black text-white tracking-tight">
              8090<span className="text-accent-500">影院</span>
            </span>
            <p className="mt-3 text-xs leading-relaxed text-foreground-400">
              8090影院提供最新电视剧全集免费高清追剧服务，影院画质同步更新，在线不缓冲，畅享流畅追剧体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3">快速导航</h4>
            <div className="space-y-2">
              <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">首页</a>
              <a href="#ranking" onClick={(e) => scrollTo(e, '#ranking')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">热播榜单</a>
              <a href="#index" onClick={(e) => scrollTo(e, '#index')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">精选专题</a>
              <a href="#cards" onClick={(e) => scrollTo(e, '#cards')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">编辑推荐</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3">服务支持</h4>
            <div className="space-y-2">
              <a href="#faq" onClick={(e) => scrollTo(e, '#faq')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" onClick={(e) => scrollTo(e, '#contact')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">联系与投稿</a>
              <a href="#updates" onClick={(e) => scrollTo(e, '#updates')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">更新动态</a>
              <a href="#app" onClick={(e) => scrollTo(e, '#app')} className="block text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">移动追剧</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              诚邀各大影视平台、内容创作者与品牌方建立合作关系，共同为广大追剧爱好者提供更丰富的观影体验。合作咨询请联系上方商务邮箱。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2021-2026 8090影院. 最新电视剧全集高清免费追剧在线不缓冲 | 影院画质同步更新
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">关于我们</a>
            <a href="#faq" onClick={(e) => scrollTo(e, '#faq')} className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">帮助中心</a>
            <a href="#contact" onClick={(e) => scrollTo(e, '#contact')} className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}